/**
 * Brixx Block Framework - Main JavaScript
 *
 * Minimal shared JavaScript for blocks across multisite.
 * Keep this minimal - most logic should be in themes or block-specific files.
 *
 * @package Brixx_Block_Framework
 * @since Brixx_Block_Framework 1.0.0
 */

// Import CSS
import '../css/style.css';

// Shared utilities can be imported here
// import './utils/helpers.js';

/**
 * Initialize Brixx Block Framework
 */
class BrixxBlockFramework {
	constructor() {
		this.init();
	}

	init() {
		// Add shared block functionality here
		// This runs on all sites in multisite
		this.initBlocks();
	}

	initBlocks() {
		// Minimal shared block initialization
		// Most block-specific JS should be in block model.php files
	}
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		new BrixxBlockFramework();
	});
} else {
	new BrixxBlockFramework();
}

